export default __webpack_public_path__ + "media/Non-food-Kitchenware.9582b51f.png";